import gql from 'graphql-tag'

const languages = JSON.parse(process.env.VUE_APP_I18N_LANGUAGES || ["DE","EN"]).map(lang => lang.toUpperCase());
const titleFields = languages.map(lang => `title${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');
const textFields = languages.map(lang => `text${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');

export const TICKER_QUERY = gql`
query Ticker($limit: Int, $countryFilter: Boolean) {
  ticker(limit: $limit, countryFilter: $countryFilter) {
    results {
      id
      text
      title
      ${titleFields}
      ${textFields}
      importantUntil
      newsType
      countries {
        id
        nameShort
        iso2
      }
      tags {
        name
        order
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      modifiedAt
      modifiedBy {
        id
        firstName
        lastName
      }
      significantUpdateAt
    }
  }
}
`
